"use strict";
var twentyninetimes = twentyninetimes || {};

twentyninetimes.cookieSetter = 
  twentyninetimes.cookieSetter ||
  (function () {
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    function setLocalStorageItem(name, value) {
        localStorage.setItem(name, value);
    }

    function checkLocalStorageItem(name) {
        return localStorage.getItem(name) !== null;
    }

    function arrayBufferToHex(buffer) {
        return Array.prototype.map.call(new Uint8Array(buffer), x => x.toString(16).padStart(2, '0')).join('');
    }
    
function generateSecureCookieValue(callback) {
    if (window.crypto && crypto.subtle) {
        window.crypto.subtle.generateKey(
            { name: "AES-GCM", length: 256 },
            true,
            ["encrypt", "decrypt"]
        )
        .then(key => window.crypto.subtle.exportKey("raw", key))
        .then(keyBuffer => {
            var hexKey = arrayBufferToHex(keyBuffer);
            callback(hexKey);
        })
        .catch(err => console.error(err));
    } else {
        // Fallback method if crypto.subtle is not available
        console.warn('Web Cryptography API not available. Using less secure random value.');
        callback(fallbackRandomValue());
    }
}

function fallbackRandomValue() {
    return Math.random().toString(36).substring(2, 15) + 
           Math.random().toString(36).substring(2, 15);
}

function checkAndSetCookie() {
    var cookieName = '_sbp';
        if (!checkLocalStorageItem(cookieName)) {
            generateSecureCookieValue((secureValue) => {
                setLocalStorageItem(cookieName, secureValue)
            });
        }

    }

    return {
      checkAndSetCookie: checkAndSetCookie,
    };
  })();